import config from '../config';

export async function fetchElionCrmOverview(backendFetch) {
    const response = await backendFetch(config.REACT_APP_HOST + "/api/v2/crm/elion-crm")
    const json = await response.json()
    return json && json.elion_crms ? json.elion_crms : [];
}

export async function validateSmartboxClaim(backendFetch, box_id) {
    try {
        const f = await backendFetch(config.REACT_APP_HOST + "/api/v2/crm/validate-smartbox-claim/" + box_id)
        const r = await f.json()
        return r.valid
    } catch (e) {
        console.error(e)
        return false
    }
}

export async function validateConnectionPointClaim(backendFetch, ean) {
    try {
        const f = await backendFetch(config.REACT_APP_HOST + "/api/v2/crm/validate-connection-point-claim/" + ean)
        const r = await f.json()
        return r.valid
    } catch (e) {
        console.error(e)
        return false
    }
}

export async function createNewInstallation(backendFetch, isDebug, siteName, siteId, boxID, crmId, partnerCompanyId, action, ean_1=null, ean_2=null) {

    const formData = new FormData();
    formData.append('site_name', siteName);
    formData.append('site_id', siteId);
    formData.append('box_id', boxID);
    formData.append('crm_id', crmId);
    formData.append('is_debug', isDebug);
    formData.append('partner_company_id', partnerCompanyId);
    formData.append('action', action);
    if (ean_1 !== null && ean_1 !== undefined) {
        formData.append('ean_1', ean_1);
    }
    if (ean_2 !== null && ean_2 !== undefined) {
        formData.append('ean_2', ean_2);
    }


    await backendFetch(config.REACT_APP_HOST + '/api/v2/crm/couple-installation', {
        method: 'PUT',
        body: formData,
    });
}

export async function fetchCrmAvailableSites(backendFetch) {
    const response = await backendFetch(config.REACT_APP_HOST + "/api/v2/crm/sites/all-available")
    return await response.json();
}